import { render, staticRenderFns } from "./BuyConfigurableProduct.vue?vue&type=template&id=97d92e34&scoped=true&"
import script from "./BuyConfigurableProduct.vue?vue&type=script&lang=js&"
export * from "./BuyConfigurableProduct.vue?vue&type=script&lang=js&"
import style0 from "./BuyConfigurableProduct.vue?vue&type=style&index=0&id=97d92e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d92e34",
  null
  
)

export default component.exports